import createPageConstants from '../shared/util/createPageConstants';
const pluginId = 'workflow';
export const WorkflowConstants = createPageConstants(pluginId, 'Workflow', {
  defaultDefault: 'workflowListPage',
  logs: 'workflowLogPage',
});
